import React from 'react';
import { User } from 'lucide-react';
import { SectionCard, SectionFields, SectionFieldConfig, SectionFieldsProps, SectionTone, withOverrides } from './SectionCard';

export type ProviderKey = 'providerName' | 'providerCredentials' | 'providerNPI' | 'supervisingPhysician' | 'supervisingPhysicianNPI' | 'dateCreated';

const FIELDS: Record<ProviderKey, SectionFieldConfig> = {
  providerName: { key: 'providerName', label: 'Provider Name', required: true, placeholder: 'Enter provider name' },
  providerCredentials: { key: 'providerCredentials', label: 'Provider Credentials' },
  providerNPI: { key: 'providerNPI', label: 'Provider NPI', placeholder: '10-digit NPI' },
  supervisingPhysician: { key: 'supervisingPhysician', label: 'Supervising Physician', placeholder: 'Physician name' },
  supervisingPhysicianNPI: { key: 'supervisingPhysicianNPI', label: 'Physician NPI', placeholder: '10-digit NPI' },
  dateCreated: { key: 'dateCreated', label: 'Date Created', kind: 'date' },
};

interface ProviderSectionProps extends SectionFieldsProps {
  /** Which provider fields the plan has, in display order */
  keys: ProviderKey[];
  overrides?: Partial<Record<ProviderKey, Partial<SectionFieldConfig>>>;
  title?: string;
  tone?: SectionTone;
  collapsed?: boolean;
  onToggle?: () => void;
}

/** Phase 19 F25: the clinician who wrote the plan (name, credentials, NPI, supervising physician, date). */
const ProviderSection: React.FC<ProviderSectionProps> = ({
  keys, overrides, title = 'Provider Information', tone = 'gray', collapsed = false, onToggle, ...fieldProps
}) => (
  <SectionCard title={title} icon={User} tone={tone} collapsed={collapsed} onToggle={onToggle}>
    <SectionFields fields={withOverrides(keys.map(k => FIELDS[k]), overrides)} columns={3} {...fieldProps} />
  </SectionCard>
);

export default ProviderSection;
